import { useEffect, useRef, useState } from 'react';
import { Help } from 'src/Components';
import { ContactType } from 'src/Types/ReDoc/Contact';
import { useAppSelector, useModal } from 'src/Hooks';
import API from 'src/API';
import './help.scss';

interface IHelpProps {
	isWidget?: boolean;
}

const HelpView: React.FC<IHelpProps> = ({ isWidget }) => {
	const { showError } = useModal();
	const isWaitRef = useRef<boolean>(false);
	const userInfo = useAppSelector((store) => {
		return store.auth;
	});
	const [contactList, setContactList] = useState<ContactType[]>([]);

	useEffect(() => {
		if (!isWaitRef.current) {
			isWaitRef.current = true;
			getLoginConfig();
		}
		// eslint-disable-next-line
	}, [isWidget]);

	const getLoginConfig = async () => {
		try {
			const contact = await API.Plugins.getSupportContacts();
			if (contact) {
				setContactList(contact);
			}
		} catch (e: any) {
			console.warn(e);
			showError(e.message, 'Внимание');
		}
	};

	return (
		<div className="help__content">
			<div className="help__content__header">
				<h1 className="headline-large">Служба поддержки</h1>
			</div>

			<Help version={userInfo.version} contactList={contactList} />
		</div>
	);
};

export default HelpView;
